import * as React from 'react';
import { graphql } from 'react-apollo';
import { QUERY } from 'components/NavigationList';
import { InjectedRouter } from 'react-router';
import { Location } from 'history';
import { withRouter } from 'app/context/Router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';

import {
  NavigationList,
  NavigationList_me_navigationSections,
} from 'queries/__generated__/NavigationList';

export type Props = {
  data: NavigationList;
  loading: boolean;
  location: Location;
  router: InjectedRouter;
};

class GroupsIndexHandler extends React.Component<Props> {
  componentDidMount() {
    const sections = this.props.data?.me?.navigationSections;

    if (sections) {
      this.redirect(sections);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const sections = this.props.data?.me?.navigationSections;
    const prevSections = prevProps.data?.me?.navigationSections;

    if (!prevSections && sections) {
      this.redirect(sections);
    }
  }

  redirect(sections: NavigationList_me_navigationSections[]) {
    const { router, location } = this.props;
    const { query } = location;

    // Get the first item of the navigation list
    const section = sections.find(s => s.items && s.items.length > 0);

    if (section && section.items && section.items.length > 0) {
      const item = section.items[0];

      if (item.__typename === 'Class') {
        router.replace({ pathname: `/classes/${item.name}`, query });
        return;
      }

      if (item.__typename === 'Organization') {
        router.replace({ pathname: `/organizations/${item.id}`, query });
        return;
      }

      if (item.__typename === 'CoachingStream') {
        router.replace({ pathname: `/coaching/messages/${item.uuid}`, query });
        return;
      }
    }

    // current user has no classes or organization then display the null view.
    router.replace({ pathname: `/classes/start`, query });
  }

  render() {
    return <CenteredLoadingIndicator />;
  }
}

const withNavigation = graphql<any, any, any>(QUERY, {
  options: () => ({ notifyOnNetworkStatusChange: true }),
});

export { GroupsIndexHandler };
export default withRouter(withNavigation(GroupsIndexHandler));
